import qs from 'query-string'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

/** Hook to transform the location's search to query parameters */
export function useQuery(): Record<string, string> {
  const location = useLocation()
  return useMemo(() => qs.parse(location.search), [location.search])
}
